// src/utils/imageUtils.js — compressione immagini lato client prima di salvarle come
// base64 dentro un documento Firestore. Un documento Firestore non può superare 1 MB in
// totale: una foto di un telefono moderno, caricata così com'è, spesso pesa da sola 2-8 MB
// — bastano una o due foto per avvicinarsi al limite, con un errore di scrittura che non
// spiega affatto perché non si riesce più ad aggiungerne altre. Ridimensionando e
// ricomprimendo prima di salvare, una foto tipica scende a 100-300 KB: molte più foto
// entrano nello stesso documento, e il margine di errore per l'utente è enorme.

const LATO_MASSIMO_PX = 1600; // sufficiente per la visualizzazione e la stampa in un rapportino
const QUALITA_JPEG = 0.75;

// Comprime un singolo File immagine e restituisce {nome, data} (data = data URL base64),
// pronto per essere inserito nello stesso array "foto" già usato ovunque nell'app.
export function comprimiImmagine(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = () => reject(new Error(`Impossibile leggere il file "${file.name}"`));
    reader.onload = () => {
      const img = new Image();
      img.onerror = () => reject(new Error(`Impossibile aprire l'immagine "${file.name}"`));
      img.onload = () => {
        let { width, height } = img;
        if (width > LATO_MASSIMO_PX || height > LATO_MASSIMO_PX) {
          if (width >= height) { height = Math.round(height * (LATO_MASSIMO_PX / width)); width = LATO_MASSIMO_PX; }
          else { width = Math.round(width * (LATO_MASSIMO_PX / height)); height = LATO_MASSIMO_PX; }
        }
        const canvas = document.createElement("canvas");
        canvas.width = width; canvas.height = height;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, width, height);
        resolve({ nome: file.name, data: canvas.toDataURL("image/jpeg", QUALITA_JPEG) });
      };
      img.src = reader.result;
    };
    reader.readAsDataURL(file);
  });
}

// Comprime più file in parallelo, nello stesso ordine — sostituto diretto del
// `Promise.all(files.map(f => new Promise(...FileReader...readAsDataURL...)))`
// ripetuto identico in più punti dell'app.
export function comprimiImmagini(files) {
  return Promise.all(Array.from(files).map(f => comprimiImmagine(f)));
}
